import { gql } from '@apollo/client';

export const BULK_UPDATE_ENTITY_SUPPRESSION_OPERATION = gql`
  mutation BulkUpdateEntitySuppressionOperation(
    $comment: String
    $entityIds: [ID!]!
    $whitelistFlag: Boolean!
  ) {
    bulkUpdateEntityWhitelist(
      comment: $comment
      entityIds: $entityIds
      whitelistFlag: $whitelistFlag
    ) {
      data {
        id
        isWhitelisted
        whitelistedComment
      }
    }
  }
`;
